import React from "react";

type SectionHeadingProps = {
    title: string;
    description?: string;
    actions?: React.ReactNode;
    className?: string;
};

export default function SectionHeading({
                                           title,
                                           description,
                                           actions,
                                           className = "",
                                       }: SectionHeadingProps) {
    return (
        <div
            className={`border-b border-gray-200 pb-5 sm:flex sm:items-start sm:justify-between ${className}`}
        >
            <div>
                <h3 className="text-2xl font-semibold text-gray-900">
                    {title}
                </h3>

                {description && (
                    <p className="mt-2 text-sm text-gray-500">
                        {description}
                    </p>
                )}
            </div>

            {actions && (
                <div className="mt-3 sm:mt-0 sm:ml-4 flex gap-2">
                    {actions}
                </div>
            )}
        </div>
    );
}